import _ from 'lodash';
import icons from '~/utils/icons';
import { mapActions, mapState } from 'vuex';
import Creative from '@/components/rabbit/campaign-creatives/creative/Creative.vue';
import CreativePreviewFeedback from '@/components/creative-preview-feedback/CreativePreviewFeedback.vue';
import { permissions, creativeDefaults, Debug } from '~';
import { CREATIVE_STATUSES } from '@/util/constants';

const debug = Debug('creative-wrapper');

export default {
  components: {
    'campaign-creative': Creative,
    'creative-preview-feedback': CreativePreviewFeedback,
  },
  props: {
    creative: Object,
    facebookPage: Object,
    disabledButtons: {
      type: Boolean,
      default: false,
    },
    enableFormPreview: {
      type: Boolean,
      default: false,
    },
    mobilePreview: {
      type: Boolean,
      default: false,
    },
    usePortal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      internalMobilePreview: true,
      isHtmlVideoSupported: !!document.createElement('video').canPlayType,
      loading: true,
    };
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('genericConfig', ['config']),
    icons() {
      return icons;
    },
    campaign() {
      const c = _.get(this.creative, 'campaign', null);
      if (c) {
        this.setCurrentCampaign(c);
      }
      return c;
    },
    isMobilePreview() {
      return !this.internalMobilePreview ? 'disabled' : '';
    },
    isDesktopPreview() {
      return this.internalMobilePreview ? 'disabled' : '';
    },
    permissions() {
      return permissions.getPermissions(this.creative);
    },
    canUpdateBriefStatus() {
      return this.isInReady && permissions.can(this.creative, ['moveForward', 'moveBack']);
    },
    isInReady() {
      return this.creative.status === CREATIVE_STATUSES.READY;
    },
    isInApproved() {
      return this.creative.status === CREATIVE_STATUSES.APPROVED;
    },
    isInHold() {
      return this.creative.status === CREATIVE_STATUSES.HOLD;
    },
    showPreview() {
      return this.isInReady || this.isInApproved || this.isInHold;
    },
    isInCreativeView() {
      return this.$router.currentRoute.name === 'creative';
    },
    firstThumbnail() {
      const leadPhoto = _.get(this.creative, 'lead_photo.thumbnail', null);
      if (leadPhoto) {
        return leadPhoto;
      }

      const firstMedia = _.get(this.creative, 'media[0].file.thumbnail', null);
      if (firstMedia) {
        return firstMedia;
      }

      return creativeDefaults.image;
    },
  },
  methods: {
    ...mapActions('campaign', ['setCurrentCampaign']),
    ...mapActions('creative', ['getCreative', 'moveForward', 'moveBack', 'reloadCreative']),
    setMobilePreview(mobile) {
      this.internalMobilePreview = mobile;
    },
    goToCreative(id) {
      this.$router.push({
        name: 'creative',
        params: { id },
      });
    },
    finish(updateComment = false) {
      return Promise.resolve(updateComment ? this.updateComment() : null)
        .then(() => this.moveForward(this.creative.id))
        .then(() => this.$toast.info({ message: this.$t('pos.creative.creative-next') }))
        .then(() => this.reloadCreative())
        .catch(e => debug('error in finish()', e));
    },
    update() {
      // #32911 Add whole page refresh when updating comment to update file list
      return Promise.resolve(this.updateComment(true))
        .then(() => this.reloadPage())
        .catch(e => debug('error in update()', e));
    },
    reloadPage() {
      window.location.reload(true);
    },
    reject() {
      return this.moveBack({
        id: this.creative.id,
        data: this.$refs.comment.getCommentData(),
      })
        .then(() => {
          if (this.$refs.comment) {
            this.$refs.comment.clearCommentData();
          }
          this.$toast.info({ message: this.$t('pos.creative.creative-rejected') });
          return this.reloadCreative();
        })
        .catch(e => {
          this.$toast.error({ message: e.toString() });
        });
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/rabbit/creative-preview-wrapper/CreativePreviewWrapper.js